module.exports = "<app-header id=\"headerTarget\"></app-header>\n<div fxHide.xs=\"false\" fxHide=\"true\" style=\"height: 60px\"></div>\n<app-about id=\"aboutTarget\" class=\"mat-typography\"></app-about>\n"


//////////////////
// WEBPACK FOOTER
// /zeit/1e2f5901/src/app/front/front.component.html
// module id = ../../../../../src/app/front/front.component.html
// module chunks = main